import script from "./downloadMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./downloadMenu.vue?vue&type=script&setup=true&lang=js"

import "./downloadMenu.vue?vue&type=style&index=0&id=d0636f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0636f2a"]])

export default __exports__